export default function SessionWarning({ show, timeLeft, onStayLoggedIn, onLogout }) {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-fadeIn">
            <div className="bg-white dark:bg-slate-800 rounded-3xl shadow-2xl p-8 max-w-md w-full text-center space-y-6">
                {/* Warning Icon */}
                <div className="w-20 h-20 mx-auto rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
                    <svg className="w-10 h-10 text-amber-600 dark:text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>

                {/* Message */}
                <div>
                    <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-2">
                        Session Expiring
                    </h3>
                    <p className="text-gray-500 dark:text-slate-400 text-sm">
                        Your session will expire due to inactivity.
                    </p>
                    <p className="text-2xl font-extrabold text-[#3a663f] dark:text-green-400 mt-3">
                        {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}
                    </p>
                    <p className="text-xs text-gray-400 dark:text-slate-500 mt-1">
                        minutes remaining
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-4">
                    <button
                        onClick={onLogout}
                        className="flex-1 py-3 border border-gray-200 dark:border-slate-600 rounded-xl text-gray-600 dark:text-slate-400 font-medium hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
                    >
                        Sign Out Now
                    </button>
                    <button
                        onClick={onStayLoggedIn}
                        className="flex-1 py-3 bg-[#3a663f] text-white rounded-xl font-semibold hover:bg-[#2d5232] transition-colors shadow-lg"
                    >
                        Stay Logged In
                    </button>
                </div>
            </div>
        </div>
    );
}// JavaScript source code
